import NotAllowed from "../../../../../components/error/not-allowed";
import { Permission } from "../../../../permission";
import { PERMISSIONS } from "../../../../role-control/constants";
import AbsenceLetterDetail from "../../absence-letter/pages/absence-letter/absence-letter-detail";
import {
  SuspendContractCreate,
  SuspendContractEdit,
  SuspendContractList,
} from "../../absence-letter/pages/suspend-contract";

export const suspendContractDADRoutes = {
  suspendContractDADPage: {
    isAdmin: false,
    title: "5. Đơn xin tạm hoãn HĐLĐ",
    path: "/procedure/suspend-contract-dad",
    parentId: "procedure",
    component: () => {
      return (
        <SuspendContractList />

        // <Permission record={{ [PERMISSIONS["SUSPEND_CONTRACT_DAD"]]: ({ R }) => R }} fallback={<NotAllowed />}>
        //   <SuspendContractList />
        // </Permission>
      );
    },
  },
  createSuspendContractDADPage: {
    isAdmin: false,
    path: "/procedure/suspend-contract-dad/create",
    parentId: "procedure",
    component: SuspendContractCreate,
  },
  detailSuspendContractDADPage: {
    isAdmin: false,
    path: "/procedure/suspend-contract-dad/:applicationForLeaveId",
    parentId: "procedure",
    component: AbsenceLetterDetail,
  },
  editSuspendContractDADPage: {
    isAdmin: false,
    path: "/procedure/suspend-contract-dad/:applicationForLeaveId/edit",
    parentId: "procedure",
    component: SuspendContractEdit,
  },
};
